module.exports = __webpack_public_path__ + "img/WechatIMG1540_1200.edcad000.png";